import { isLayerSwitcherGroup } from './layerGroup';
export const getLayerIds = (config) => {
    if (isLayerSwitcherGroup(config)) {
        return config.children.reduce((acc, item) => {
            return [...acc, ...getLayerIds(item)];
        }, []);
    }
    else {
        return [config.layerId];
    }
};
export const getExclusiveLayerIds = (config) => {
    if (isLayerSwitcherGroup(config)) {
        if (!config.isExclusive) {
            return config.children.reduce((acc, item) => {
                return [...acc, ...getExclusiveLayerIds(item)];
            }, []);
        }
        else {
            return config.children.reduce((acc, item) => {
                return [...acc, ...getLayerIds(item)];
            }, []);
        }
    }
    else {
        return [];
    }
};
export function setSubstract(all, exclude) {
    return all.filter((item) => !exclude.includes(item));
}
//# sourceMappingURL=getLayerIds.js.map